import React from 'react'
import RegisterExhibitorForm from "../../components/eventLayout/sponsors/RegisterExhibitor";

const RegisterExhibitor = () => {
  return (
    <RegisterExhibitorForm />
  )
}

export default RegisterExhibitor